import { generatePath } from "react-router-dom";
import type { PipelineStageId } from "@gs/core/domain/PipelineStage/PipelineStage";
import type { JsonGroup } from "@react-awesome-query-builder/core";
import type { CompanyId } from "@gs/core/domain/Company/Company";
import basePath from "../const";

export const companyIdParamName = "companyId";
export const companiesPath = `${basePath}/companies/:${companyIdParamName}?`;

export const companiesPageQueryParams = {
  PAGE: "page",
  PAGE_SIZE: "pageSize",
  SEARCH: "q",
  PIPELINE_STAGE_ID: "stage",
  ADVANCED: "advanced",
} as const;

export const getLinkToCompaniesPage = (args?: {
  companyId?: CompanyId
  pipelineStageId?: PipelineStageId
  query?: string
  page?: number
  pageSize?: number
  advancedFilter?: JsonGroup
}) => {
  const pathname = generatePath(companiesPath, { [companyIdParamName]: args?.companyId });

  // TODO

  return pathname;
};

export default companiesPath;
